import * as types from '../actions/actionTypes';
import { combineReducers } from 'redux';
import initialState from './initialState';

const policy = (state = initialState.registration.policy, action) => {
	switch (action.type) {
		case types.REGISTRATION__REQUIRE_STAFF_VERIFICATION:
			return { ...state, requiresStaffVerification: action.requiresStaffVerification, error: null };
		case types.REGISTRATION__VERIFY_POLICY_BYSTAFF_REQUEST:
		case types.REGISTRATION__VERIFY_FULL_POLICY_REQUEST:
		case types.REGISTRATION__VERIFY_POLICY_REQUEST:
			return { ...state, loading: true, error: null };
		case types.REGISTRATION__VERIFY_POLICY_FAILURE: {
            const registrationFailureCount = state.registrationFailureCount + 1;
            const requiresStaffVerification = registrationFailureCount >= 3;
			return { ...state, loading: false, verifiedPart1: false, error: requiresStaffVerification ? null : action.error, registrationFailureCount, requiresStaffVerification };
        }
		case types.REGISTRATION__VERIFY_POLICY_SUCCESS: {
			const notValid = action.response.isValid ? null : 'Matching Policy Not Found!';
			return { ...state, loading: false, verifiedPart1: action.response.isValid, error: notValid, registrationFailureCount: 0, requiresStaffVerification: false };
		}
		case types.REGISTRATION__VERIFY_FULL_POLICY_FAILURE: {
            const registrationFailureCount = state.registrationFailureCount + 1;
            const requiresStaffVerification = registrationFailureCount >= 3;
			return { ...state, loading: false, verifiedPart2: false, error: requiresStaffVerification ? null : action.error, registrationFailureCount, requiresStaffVerification };
        }
		case types.REGISTRATION__VERIFY_FULL_POLICY_SUCCESS: {
			const notValid = action.response.isValid ? null : 'Matching Policy Not Found!';
			return { ...state, loading: false, requiresStaffVerification: !action.response.isValid, verifiedPart2: action.response.isValid, error: notValid, registrationFailureCount: 0 };
		}
		case types.REGISTRATION__VERIFY_POLICY_BYSTAFF_FAILURE:
			return { ...state, loading: false, staffVerificationRequestCompleted: false, error: action.error };
		case types.REGISTRATION__VERIFY_POLICY_BYSTAFF_SUCCESS: {
			const staffVerificationRequestCompleted = action.response.staffVerificationRequestCompleted ? null : 'Check the information provided!';
			return { ...state, loading: false, staffVerificationRequestCompleted: action.response.staffVerificationRequestCompleted, error: staffVerificationRequestCompleted };
		}
		case types.REGISTRATION__UPDATE_POLICY:
			return { ...state, ...action.policy };
		case types.LOGOUT__USER_SUCCESS:
			return { ...initialState.registration.policy };
		default:
			return state;
	}
};

const user = (state = initialState.registration.user, action) => {
	switch (action.type) {
		case types.PROFILE__CHANGE_EMAIL_FAILURE:
		case types.PROFILE__CHANGE_PASSWORD_FAILURE:
		case types.AUTH__RESET_PASSWORD_FAILURE:
		case types.REGISTRATION__CREATE_USER_FAILURE:
			return { ...state, loading: false, verified: false, error: action.error };
		case types.PROFILE__CHANGE_EMAIL_REQUEST:
		case types.PROFILE__CHANGE_PASSWORD_REQUEST:
		case types.AUTH__RESET_PASSWORD_REQUEST:
		case types.REGISTRATION__CREATE_USER_REQUEST:
			return { ...state, loading: true, error: null };
		case types.REGISTRATION__CREATE_USER_SUCCESS:
			return { ...state, loading: false, created: true };
		case types.AUTH__RESET_PASSWORD_SUCCESS:
			return { ...state, loading: false, passwordReset: true };
		case types.PROFILE__CHANGE_PASSWORD_SUCCESS:
			return { ...state, loading: false, passwordChanged: true };
		case types.PROFILE__CHANGE_EMAIL_SUCCESS:
			return { ...state, loading: false, emailChanged: true };
		case types.PROFILE__EMAIL_CHANGED:
		case types.PROFILE__PASSWORD_CHANGED:
			return initialState.registration.user;
		case types.REGISTRATION__UPDATE_USER:
			return { ...state, ...action.user };
		case types.LOGOUT__USER_SUCCESS:
			return initialState.registration.user;
		default:
			return state;
	}
};

const registrationReducer = combineReducers({
	user,
	policy,
});
export default registrationReducer;
